/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowPerformer } from './ShowPerformer';
import {
    ShowPerformerFromJSON,
    ShowPerformerFromJSONTyped,
    ShowPerformerToJSON,
    ShowPerformerToJSONTyped,
} from './ShowPerformer';
import type { ShowTypeEnum } from './ShowTypeEnum';
import {
    ShowTypeEnumFromJSON,
    ShowTypeEnumFromJSONTyped,
    ShowTypeEnumToJSON,
    ShowTypeEnumToJSONTyped,
} from './ShowTypeEnum';
import type { ShowStage } from './ShowStage';
import {
    ShowStageFromJSON,
    ShowStageFromJSONTyped,
    ShowStageToJSON,
    ShowStageToJSONTyped,
} from './ShowStage';
import type { Status02dEnum } from './Status02dEnum';
import {
    Status02dEnumFromJSON,
    Status02dEnumFromJSONTyped,
    Status02dEnumToJSON,
    Status02dEnumToJSONTyped,
} from './Status02dEnum';

/**
 * Show serializer with nested relationships.
 * Show is aggregate/rollup of Hold data.
 * @export
 * @interface PatchedShow
 */
export interface PatchedShow {
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    description?: string;
    /**
     * 
     * @type {ShowTypeEnum}
     * @memberof PatchedShow
     */
    showType?: ShowTypeEnum;
    /**
     * 
     * @type {Status02dEnum}
     * @memberof PatchedShow
     */
    status?: Status02dEnum;
    /**
     * Show date - null for tentative shows until confirmed
     * @type {Date}
     * @memberof PatchedShow
     */
    showDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    doorsTime?: string | null;
    /**
     * Preferred show time - null for tentative shows
     * @type {string}
     * @memberof PatchedShow
     */
    showTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    endTime?: string | null;
    /**
     * Actual attendance count
     * @type {number}
     * @memberof PatchedShow
     */
    readonly attendance?: number | null;
    /**
     * Total ticket sales
     * @type {string}
     * @memberof PatchedShow
     */
    readonly ticketRevenue?: string | null;
    /**
     * Bar/concessions revenue
     * @type {string}
     * @memberof PatchedShow
     */
    readonly barRevenue?: string | null;
    /**
     * Merchandise, parking, etc.
     * @type {string}
     * @memberof PatchedShow
     */
    readonly otherRevenue?: string | null;
    /**
     * Production, staffing, etc.
     * @type {string}
     * @memberof PatchedShow
     */
    readonly totalExpenses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    readonly totalRevenue?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    readonly netProfit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedShow
     */
    readonly isSettled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PatchedShow
     */
    readonly settlementDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    settlementNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    notes?: string;
    /**
     * Team that created/manages this show
     * @type {number}
     * @memberof PatchedShow
     */
    team?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    readonly teamName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedShow
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedShow
     */
    readonly createdBy?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof PatchedShow
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedShow
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {Array<ShowStage>}
     * @memberof PatchedShow
     */
    readonly showStages?: Array<ShowStage>;
    /**
     * 
     * @type {Array<ShowPerformer>}
     * @memberof PatchedShow
     */
    readonly showPerformers?: Array<ShowPerformer>;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    readonly venue?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    readonly holdBreakdown?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    readonly holdCount?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShow
     */
    readonly dateRange?: string;
}



/**
 * Check if a given object implements the PatchedShow interface.
 */
export function instanceOfPatchedShow(value: object): value is PatchedShow {
    return true;
}

export function PatchedShowFromJSON(json: any): PatchedShow {
    return PatchedShowFromJSONTyped(json, false);
}

export function PatchedShowFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedShow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'showType': json['show_type'] == null ? undefined : ShowTypeEnumFromJSON(json['show_type']),
        'status': json['status'] == null ? undefined : Status02dEnumFromJSON(json['status']),
        'showDate': json['show_date'] == null ? undefined : (new Date(json['show_date'])),
        'doorsTime': json['doors_time'] == null ? undefined : json['doors_time'],
        'showTime': json['show_time'] == null ? undefined : json['show_time'],
        'endTime': json['end_time'] == null ? undefined : json['end_time'],
        'attendance': json['attendance'] == null ? undefined : json['attendance'],
        'ticketRevenue': json['ticket_revenue'] == null ? undefined : json['ticket_revenue'],
        'barRevenue': json['bar_revenue'] == null ? undefined : json['bar_revenue'],
        'otherRevenue': json['other_revenue'] == null ? undefined : json['other_revenue'],
        'totalExpenses': json['total_expenses'] == null ? undefined : json['total_expenses'],
        'totalRevenue': json['total_revenue'] == null ? undefined : json['total_revenue'],
        'netProfit': json['net_profit'] == null ? undefined : json['net_profit'],
        'isSettled': json['is_settled'] == null ? undefined : json['is_settled'],
        'settlementDate': json['settlement_date'] == null ? undefined : (new Date(json['settlement_date'])),
        'settlementNotes': json['settlement_notes'] == null ? undefined : json['settlement_notes'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'team': json['team'] == null ? undefined : json['team'],
        'teamName': json['team_name'] == null ? undefined : json['team_name'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdBy': json['created_by'] == null ? undefined : json['created_by'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'showStages': json['show_stages'] == null ? undefined : ((json['show_stages'] as Array<any>).map(ShowStageFromJSON)),
        'showPerformers': json['show_performers'] == null ? undefined : ((json['show_performers'] as Array<any>).map(ShowPerformerFromJSON)),
        'venue': json['venue'] == null ? undefined : json['venue'],
        'holdBreakdown': json['hold_breakdown'] == null ? undefined : json['hold_breakdown'],
        'holdCount': json['hold_count'] == null ? undefined : json['hold_count'],
        'dateRange': json['date_range'] == null ? undefined : json['date_range'],
    };
}

  export function PatchedShowToJSON(json: any): PatchedShow {
      return PatchedShowToJSONTyped(json, false);
  }

  export function PatchedShowToJSONTyped(value?: Omit<PatchedShow, 'id'|'attendance'|'ticket_revenue'|'bar_revenue'|'other_revenue'|'total_expenses'|'total_revenue'|'net_profit'|'is_settled'|'settlement_date'|'team_name'|'created_by'|'created_at'|'updated_at'|'show_stages'|'show_performers'|'venue'|'hold_breakdown'|'hold_count'|'date_range'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'show_type': ShowTypeEnumToJSON(value['showType']),
        'status': Status02dEnumToJSON(value['status']),
        'show_date': value['showDate'] == null ? undefined : ((value['showDate'] as any).toISOString().substring(0,10)),
        'doors_time': value['doorsTime'],
        'show_time': value['showTime'],
        'end_time': value['endTime'],
        'settlement_notes': value['settlementNotes'],
        'notes': value['notes'],
        'team': value['team'],
        'is_active': value['isActive'],
    };
}

